import * as React from "react";
import { QRCode } from "react-qrcode-logo";
import { ReactComponent as ArrowWarmUpIcon } from "./../../assets/images/icons/Google SVGs/arrow_warm_up.svg";
import { ReactComponent as PazirezLogo } from "./../../assets/images/Logo/Logo-Pazirex-Pure-Black.svg";
import "../../Styles/classess.scss";

export class ComponentToPrint extends React.PureComponent {
  componentDidMount() {
    // Your canvas drawing code here if needed
  }

  render() {
    const { text, subtext, targetLink } = this.props;

    return (
      <div className="relativeCSS print-container text-black">
        <style type="text/css" media="print">
          {`
            @page {
              size: A4;
              margin: 1cm;
            }

            .print-container {
              font-family: "IRANSans", sans-serif;
            }

            .print-container span {
              font-family: "IRANSans", sans-serif;
            }
          `}
        </style>
        <div className="flash" />

        <div
          className="d-none d-print-flex flex-column align-items-center w-100"
          style={{ width: "210mm", height: "297mm", padding: "6.35mm" }}
        >
          <div
            className="d-flex w-100"
            style={{
              background: "#e9ecef",
              height: "95.29mm",
              borderRadius: "16px",
            }}
          ></div>
          <div
            className="d-flex w-100"
            style={{ background: "#FFFFFF", height: "189.88mm" }}
          ></div>
          <div
            className="d-flex w-100 align-items-center justify-content-center rounded-pill"
            style={{
              background: "#e9ecef",
              height: "12mm",
            }}
          >
            <PazirezLogo className="d-flex me-2" style={{ height: "8.46mm" }} />
            <span
              className="d-flex color-iso-black m-0 p-0"
              style={{ fontSize: "4.23mm", lineHeight: "1.5" }}
            >
              مرجع جامع نوبت دهی
            </span>
          </div>

          <div
            className="position-absolute d-flex flex-column px-2"
            style={{ top: "11.85mm", height: "50.35mm", width: "195mm" }}
          >
            <div className="d-flex flex-column border-bottom border-1 border-bootstrap-gray-400 w-100">
              <span
                style={{
                  fontFamily: "IRANSans",
                  fontSize: "5.5mm",
                  fontWeight: "700",
                  lineHeight: "8.25mm",
                  textAlign: "center",
                  color: "#000000",
                  marginLeft: "auto",
                  marginRight: "auto",
                  marginBottom: "2.11mm",
                }}
              >
                {text ?? "متن پیش فرض"}
              </span>
              {subtext && (
                <span
                  style={{
                    fontFamily: "IRANSans",
                    fontSize: "5.5mm",
                    fontWeight: "500",
                    lineHeight: "8.25mm",
                    textAlign: "center",
                    color: "#5F5F5F",
                    marginLeft: "auto",
                    marginRight: "auto",
                    marginBottom: "2.11mm",
                  }}
                >
                  {subtext}
                </span>
              )}
            </div>

            {/* text */}
            <div
              className="d-flex px-4 mt-4 rounded-3 justify-content-center"
              style={{
                // background: "#E9ECEF",
                fontSize: "6.5mm",
                lineHeight: "9.7mm",
              }}
            >
              برای دریافت نوبت کد QR زیر را اسکن کنید
            </div>

            {/* Arrow */}
            <div
              className="d-flex flex-row mt-2 align-items-center justify-content-center w-100"
              style={{ marginBottom: "18px" }}
            >
              <div className="d-flex justify-content-center">
                <ArrowWarmUpIcon
                  width={"11.29mm"}
                  height={"11.29mm"}
                  style={{ marginLeft: "12.7mm" }}
                />
              </div>
              <div className="d-flex  justify-content-center">
                <ArrowWarmUpIcon
                  width={"11.29mm"}
                  height={"11.29mm"}
                  style={{ marginLeft: "12.7mm" }}
                />
              </div>
              <div className="d-flex  justify-content-center">
                <ArrowWarmUpIcon
                  width={"11.29mm"}
                  height={"11.29mm"}
                  style={{ marginLeft: "12.7mm" }}
                />
              </div>
              <div className="d-flex  justify-content-center">
                <ArrowWarmUpIcon width={"11.29mm"} height={"11.29mm"} />
              </div>
            </div>

            {/* QR */}
            <div
              className="d-flex rounded-5 mx-auto"
              style={{
                background:
                  "linear-gradient(91.65deg, #056BF1 3.83%, #124A94 99.47%)",
                padding: "6.62mm",
              }}
            >
              <div
                className="d-flex rounded-5 bg-white"
                style={{ padding: "4.41mm" }}
              >
                <QRCode
                  value={targetLink ? targetLink : window.location.href}
                  size={384}
                  qrStyle="fluid"
                  quietZone={0}
                  ecLevel="L"
                  eyeRadius={[
                    {
                      outer: [22.66, 22.66, 0, 22.66],
                      inner: [0, 0, 0, 0],
                    },
                    {
                      outer: [22.66, 22.66, 22.66, 0],
                      inner: [0, 0, 0, 0],
                    },
                    {
                      outer: [22.66, 0, 22.66, 22.66],
                      inner: [0, 0, 0, 0],
                    },
                  ]}
                />
              </div>
            </div>

            <div
              className="d-flex flex-column mx-auto"
              style={{
                maxWidth: "150mm",
              }}
            >
              <div
                className="d-flex py-1 justify-content-start"
                style={{
                  fontSize: "5.5mm",
                  lineHeight: "12.1mm",
                  marginTop: "6.35mm",
                }}
              >
                1. با استفاده از نرم‌افزار QR یا دوربین گوشی کدQR بالا را اسکن
                کنید.
              </div>
              <div
                className="d-flex py-1 justify-content-start"
                style={{
                  fontSize: "5.5mm",
                  lineHeight: "12.1mm",
                }}
              >
                2. پس از اسکن یک لینک به شما نمایش داده می‌شود.
              </div>
              <div
                className="d-flex py-1 justify-content-start"
                style={{
                  fontSize: "5.5mm",
                  lineHeight: "12.1mm",
                }}
              >
                3. روی لینک زده سپس وارد صفحه نوبت‌دهی مدنظر شوید.
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export const FunctionalComponentToPrint = React.forwardRef((props, ref) => {
  return <ComponentToPrint ref={ref} {...props} />;
});
